<div class="d-flex justify-content-between align-items-center w-100 mb-3 r-text-base bg-primary text-white ps-2">
    <div class="heavy text-nowrap">{{title}}</div>
    <span></span>
</div>
